import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AreaMappingRFQMaintenanceGetRequest } from '../pages/area-mapping-rfq-maintenance/interface/area-mapping-rfq-maintenance-get-request';
import { AreaMappingRFQMaintenanceGetResponse } from '../pages/area-mapping-rfq-maintenance/interface/area-mapping-rfq-maintenance-get-response';
import { AreaMappingRFQMaintenanceSaveRequest } from '../pages/area-mapping-rfq-maintenance/interface/area-mapping-rfq-maintenance-save-request';

@Injectable({
  providedIn: 'root'
})
export class AreaMappingRFQMaintenanceService {

  private baseUrl: string = `${environment.logisticsApiUrl}/areaMappingRFQ/maintenance`
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  constructor(
    private http: HttpClient
  ) { }

  getAreaMappingRFQ(request: AreaMappingRFQMaintenanceGetRequest): Observable<AreaMappingRFQMaintenanceGetResponse> {
    return this.http.post<AreaMappingRFQMaintenanceGetResponse>(this.baseUrl, request, this.httpOptions);
  }

  saveAreaMappingRFQChanges(request: AreaMappingRFQMaintenanceSaveRequest): Observable<void> {
    return this.http.put<void>(this.baseUrl, request, this.httpOptions);
  }
}
